export const environment = {
  URL: 'https://dvm.alpha.simadvisory.com/spriced/platform',
  SELF_SERVICE_API_BASE_URL: 'https://dvm.alpha.simadvisory.com',
  SELF_SERVICE_CHAT_API_URL: 'https://dvm.alpha.simadvisory.com/spriced/platform/ppt-dashboard/generate',
  KAVERI_DASHBOARD_CONFIG_BASE_URL: 'https://dvm.alpha.simadvisory.com/spriced/platform',
  KEYCLOAK_URL: 'https://auth.alpha.simadvisory.com',
  KEYCLOAK_REALM: 'D_SPRICED',
  KEYCLOAK_CLIENT_ID: 'D_SPRICED_Client',
  bearer_token: true,
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  CLIENT_LOGO_SRC: "",
  CLIENT_LOGO_ICON: "",
  CLIENT_LOGO_TEXT: "",
  COMPANY_LOGO_SRC: "https://assets.alpha.simadvisory.com/logos/image.png",
  COMPANY_LOGO_TEXT: "LaDesi 1.0",
  // DEFAULT_COMPANY_LOGO — local SVG SIM Advisory logo; takes precedence over COMPANY_LOGO_SRC when set.
  DEFAULT_COMPANY_LOGO: "assets/default-company-logo.svg",
  DEFAULT_MAKE_INDIA_LOGO: "assets/default-make-in-India-logo.svg",
  SECONDARY_LOGO_SRC: "https://assets.alpha.simadvisory.com/Make-in-india.png",
  SECONDARY_LOGO_ENABLED: "false",
  HEADER_COLOR: '',
  SECONDARY_COLOR: '#3688df',
  SECONDARY_COLOR_2: '#3688df',
  ICON_URL: "https://assets.alpha.simadvisory.com/logos/image.png",
  TAB_NAME: "Kaveri Lite",
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  CHAT_ENABLED: "false",
  agentApiUrl: 'http://localhost:8081',
  THEME_NAME: 'default',
  USE_ALT_SIDENAV: false,
  THEME_OPTIONS_ENABLED: true,
  THEME_TOGGLE_ENABLED: true,
  PUBLISHED_VIEWS_RAIL_ENABLED: false,
  ALT_COMPANY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/cummins_white.png',
  ALT_SECONDARY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/logos/sim-logo-white.png',
  PROJECT_MODE_QA: false,
  PROJECT_MODE_UAT: false,
  PROJECT_MODE: false,
  LANDING_ROUTE: 'dvm-published/consolidated_customer_screen_f3h11a',
};
